import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Dialog, DialogTitle, DialogContent, DialogActions, Divider, Button, Typography, Box } from '@mui/material';
import { API } from 'utils/api';

const GOLD = '#C9A84C';

const AccountNoticeDialog = () => {
  const navigate = useNavigate();
  const [notice, setNotice] = useState(null);

  const load = () => {
    API.get('/api/user/notices')
      .then((res) => {
        const body = res.data || {};
        const list = (body.success && Array.isArray(body.data) ? body.data : []).filter((n) => n && !n.acked);
        setNotice(list[0] || null);
      })
      .catch(() => {});
  };

  useEffect(() => {
    load();
  }, []);

  const ack = async (goWallet) => {
    if (!notice) return;
    try {
      await API.post(`/api/user/notices/${notice.id}/ack`);
    } catch (e) {
      /* ignore */
    }
    setNotice(null);
    if (goWallet) {
      navigate('/panel/wallet');
    } else {
      load();
    }
  };

  if (!notice) return null;

  const isLow = notice.kind === 'low_balance';

  return (
    <Dialog open fullWidth maxWidth="xs" onClose={() => ack(false)}>
      <DialogTitle sx={{ fontWeight: 700, p: '20px 24px', fontSize: '1.05rem' }}>{notice.title}</DialogTitle>
      <Divider />
      <DialogContent>
        <Box sx={{ mt: 0.5 }}>
          <Typography sx={{ color: '#5b5340', lineHeight: 1.7, fontSize: 14.5, whiteSpace: 'pre-wrap' }}>{notice.body}</Typography>
          {isLow && (
            <Typography variant="caption" sx={{ display: 'block', mt: 1.5, color: '#9a8a55' }}>
              预警线是最近一笔充值金额的 20%。充值到账后这条提醒会自动消失。
            </Typography>
          )}
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: '14px 24px' }}>
        <Button onClick={() => ack(false)} sx={{ color: '#8b6520' }}>
          我知道了
        </Button>
        <Button
          variant="contained"
          onClick={() => ack(true)}
          sx={{ background: GOLD, color: '#3a2f10', '&:hover': { background: '#b9982f' } }}
        >
          {isLow ? '去充值' : '去钱包看看'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AccountNoticeDialog;
